export const twitterLink = 'https://twitter.com/grafbase'
export const linkedinLink = 'https://linkedin.com/company/grafbase'
export const discordLink = 'https://discord.gg/grafbase'
export const githubLink = 'https://github.com/grafbase'
export const discordShowcaseLink =
  'https://discord.com/channels/890534438151274507/919941661780504596'
export const youtubeLink = 'https://www.youtube.com/@grafbase'
